import { useRef } from 'react';
import { Swiper as SwiperType, Navigation, Pagination } from 'swiper';
import { SwiperSlide, Swiper } from 'swiper/react';

import { AscHeading, AscLink, AscEventCard } from '@ascendnow/ascend-components';
import { PLATFORM_ROUTES } from '@platform/constants';
import { useAppSelector } from '../../store';

import styles from '@platform/styles/pages/home.module.scss';

export const AscDashboardEvents = () => {
    const swiperRef = useRef<SwiperType>();
    const { popular, fetchingPopular } = useAppSelector((state) => state.event);

    if (popular?.length > 0) {
        return (
            <div className={styles.section}>
                <div className={styles.sectionHeader}>
                    <AscHeading level={5}>Popular Events</AscHeading>
                    <AscLink
                        href={PLATFORM_ROUTES.events}
                        className={styles.sectionHeaderSeeAll}
                        showIcon
                        innerWrapperTag="button"
                    >
                        See all
                    </AscLink>
                </div>
                {popular && Array.isArray(popular) && popular?.length > 0 && (
                    <Swiper
                        slidesPerView="auto"
                        spaceBetween={20}
                        pagination={{ clickable: true }}
                        modules={[Navigation, Pagination]}
                        onBeforeInit={(swiper) => {
                            swiperRef.current = swiper;
                        }}
                        className={styles.eventItems}
                    >
                        {popular?.map((popularEvent) => (
                            <SwiperSlide key={popularEvent.id} style={{ width: 'fit-content' }}>
                                <AscEventCard
                                    loading={fetchingPopular}
                                    key={popularEvent?.id}
                                    title={popularEvent.name}
                                    date={popularEvent.date}
                                    type={popularEvent?.eventType}
                                    coverImageUrl={popularEvent?.thumbnail?.location}
                                    eventPath={
                                        popularEvent?.stageId
                                            ? `${PLATFORM_ROUTES.tracks_entrepreneurship_track_bullpen_application}/${popularEvent?.id}`
                                            : `${PLATFORM_ROUTES.events}/${popularEvent?.id}`
                                    }
                                    isUpcoming
                                />
                            </SwiperSlide>
                        ))}
                    </Swiper>
                )}
            </div>
        );
    }

    return <></>;
};
